// extracted by mini-css-extract-plugin
export default {"Tab":"Menu_Tab__w74sO","Active":"Menu_Active__ewQpM","Menu":"Menu_Menu__7a9dq"};